window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import ZiggyRoute from 'ziggy';
import { Ziggy } from './ziggy';

import $ from 'jquery';

window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/sortable.js';
import PortalVue from 'portal-vue';

try {
  window.Popper = require('popper.js').default;

  /* This library polyfills the native IntersectionObserver API in unsupporting browsers. */
  require('intersection-observer');

  require('jquery-ui');

  window.zRoute = (name, params) => ZiggyRoute(name, params, false, Ziggy);

  require('bootstrap');
  require('owl.carousel');
  require('magnific-popup');
  window.introJs = require('intro.js');
  window.Cropper = require('cropperjs');
  window.Noty = require('noty');
  require('./scripts/userProfile.js');
  require('./scripts/custom');
  window.debounce = require('./scripts/debounce').default;
  Vue.use(PortalVue);
} catch (e) {
  console.log('Error:');
  console.log(e);
}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

/**
 * Regex from http://detectmobilebrowsers.com/
 */
const isMobile = (function (a) {
  return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) ? true : false;
})(navigator.userAgent || navigator.vendor || window.opera);

window.appVersionCode = 196;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Platform'] = isMobile ? 'mobile' : 'pc';
window.axios.defaults.headers.common['Version-Code'] = window.appVersionCode;


/**
 * UUID for VUE APP request;
 */
let uuid = document.head.querySelector('meta[name="uuid"]');
if (uuid) {
  window.axios.defaults.headers.common['X-UUID-TOKEN'] = uuid.content;
}

window.axios.interceptors.response.use(function (response) {
  if (response.data && response.data.csrfToken) {
    const meta = document.querySelector('meta[name=csrf-token]');
    if (meta) {
      meta.setAttribute('content', response.data.csrfToken);
    }
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
  }
  return response;
}, function (error) {
  const response = error.response;
  if (response.status !== 200 && response.data && response.data.reason) {
    if (response.data.reason === window.globals.actions.ACTION_NOT_ENOUGH_COINS) {
      window.eventHub.$emit('EventPopupModalOpen', response.data.reason);
      // window.eventHub.$emit('EventPopupModalOpen', 'not_enough_coins');
      // window.vApp.$store.commit('notifications/addNotification', response.data.popup);
      // window.eventHub.$emit('EventPopupModalOpen', window.globals.actions.ACTION_NOT_ENOUGH_COINS);
      // window.location.href = zRoute('front.more_settings.payment', 'credits');
    }

    if (response.data.reason === window.globals.actions.ACTION_PAYWALL_PAYMENT) {
      window.eventHub.$emit('EventPopupModalOpen', response.data.reason);
      // window.eventHub.$emit('EventPopupModalOpen', 'paywall_payment');
    }
  }

  if (response.status === 419) {
    window.location.reload(true);
  }

  if (response.status === 500) {
    window.debounce(() => {
      window.vApp.$notify({
        group: 'custom-template',
        type: 'error',
        title: 'Error',
        text: 'System error',
        duration: 5000,
        data: {},
      });
    });
  }

  return Promise.reject(error);
});


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  disableStats: true,
  enableStats: false,
  enabledTransports: [
    'ws',
    'wss',
    // 'xhr_streaming',
    // 'xhr_polling',
    // 'sockjs',
  ],
});
